export function parseEnumDef(def) {
    return {
        type: "string",
        enum: Array.from(def.values),
    };
}
